module.exports = __webpack_public_path__ + "img/evaluation.dde49310.png";